const formatDateToRelativeTimeDisplay = (
  date: string | null
): string | null => {
  // if date is null, return null
  if (date === null) return null;

  const dateObj = new Date(date);

  // if date is invalid, return null
  if (isNaN(dateObj.getTime())) return null;

  const now = new Date();

  const isToday =
    dateObj.getDate() === now.getDate() &&
    dateObj.getMonth() === now.getMonth() &&
    dateObj.getFullYear() === now.getFullYear();

  if (isToday) {
    return dateObj.toLocaleTimeString("de-DE", {
      hour: "2-digit",
      minute: "2-digit",
    });
  }

  return (
    dateObj.toLocaleDateString("de-DE", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    }) +
    " " +
    dateObj.toLocaleTimeString("de-DE", {
      hour: "2-digit",
      minute: "2-digit",
    })
  );
};

export default formatDateToRelativeTimeDisplay;
